// One request per grid; keep the server-rendered next-page links as fallback.
(() => {
  if (window.Eurus.loadedScript.has('pagination.js')) return;
  window.Eurus.loadedScript.add('pagination.js');
  const register = () => window.Alpine.data('xPagination', (sectionId) => ({
    loading: false,
    error: false,
    _controller: null,
    _loadedUrls: new Set(),
    destroy() { this._controller?.abort(); },
    onClick(event) {
      // Preserve open-in-new-tab and the ordinary href when JS is unavailable.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      this.loadData(event.currentTarget.href, event.detail === 0);
    },
    async loadData(url, focusNewCard = false) {
      if (this.loading) return;
      const root = document.getElementById(`btn-pagination-${sectionId}`);
      const section = root?.closest('.shopify-section');
      const grid = section?.querySelector('#items-grid, #blog-grid');
      if (!root || !grid) return;
      const requestUrl = new URL(url, window.location.href);
      if (requestUrl.origin !== window.location.origin || this._loadedUrls.has(requestUrl.href)) return;
      const startingLocation = window.location.pathname + window.location.search;
      const currentCards = Array.from(grid.children);
      const current = () => root.isConnected && grid.isConnected &&
        document.getElementById(root.id) === root &&
        section.querySelector('#items-grid, #blog-grid') === grid &&
        window.location.pathname + window.location.search === startingLocation &&
        currentCards.length === grid.children.length && currentCards.every((card, i) => grid.children[i] === card);
      this.loading = true;
      this.error = false;
      const controller = new AbortController();
      this._controller = controller;
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(requestUrl.href, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Pagination HTTP failure');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!current()) return; // Filters / sorting / navigation superseded this request.
        const sourceRoot = html.getElementById(root.id);
        const sourceGrid = html.getElementById(grid.id);
        const newCards = sourceGrid ? Array.from(sourceGrid.children).filter(card => card.matches('.grid-item')) : [];
        if (!sourceRoot || !newCards.length) throw new Error('Pagination response incomplete');
        const key = card => card.querySelector('a[href*="/products/"], a[href*="/blogs/"]')?.getAttribute('href')?.split('?')[0] || card.id;
        const seen = new Set(currentCards.map(key).filter(Boolean));
        for (const card of newCards) {
          const identity = key(card);
          if (identity && seen.has(identity)) throw new Error('Pagination overlap; reload the next page');
          if (identity) seen.add(identity);
        }
        // Commit the validated batch at once; image loading stays native/lazy.
        const fragment = document.createDocumentFragment();
        newCards.forEach(card => fragment.appendChild(card));
        grid.appendChild(fragment);
        this._loadedUrls.add(requestUrl.href);
        const jumpWasOpen = !!root.querySelector('details[open]');
        root.innerHTML = sourceRoot.innerHTML;
        if (jumpWasOpen) root.querySelector('details')?.setAttribute('open', '');
        if (focusNewCard) newCards[0].querySelector('a[href]')?.focus({preventScroll: true});
        window.yotpoWidgetsContainer?.initWidgets?.();
      } catch (error) {
        // Keep current cards, the retry control and a real navigation alternative.
        if (current()) this.error = true;
      } finally {
        clearTimeout(timeout);
        if (this._controller === controller) this._controller = null;
        this.loading = false;
      }
    }
  }));
  if (window.Alpine) register();
  else document.addEventListener('alpine:init', register, {once: true});
})();
